import React, { useCallback, useMemo } from "react";
import { Rnd } from "../dragAndDrop/dragAndDrop";
import { colors } from "../../constants/colors";

type StallBoxProps = {
  index: number;
  x: number | string;
  y: number | string;
  width: number | string;
  height: number | string;
  label: string;
  bgColor?: string;
  enableResizing: boolean;
  disableDragging: boolean;
  dragGrid: any;
  /** true = ส่งค่าตอนปล่อยเมาส์ (onResizeStop) แทนที่จะส่งทุก tick ของ onResize */
  commitOnStop?: boolean;
  onSelect: (index: number) => void;
  onDragStop: (index: number, d: any) => void;
  onResizeCommit: (index: number, ref: any, position: any) => void;
};

/**
 * Rnd เป็น React.PureComponent อยู่แล้ว แต่ถ้า parent ส่ง object literal
 * (style / size / position) และ closure ใหม่ทุก render การเทียบ shallow จะไม่ผ่านเลย
 * component นี้จึงรับเฉพาะ primitive แล้ว memo ค่าเหล่านั้นไว้ข้างใน
 */
function StallBoxBase(props: StallBoxProps) {
  const {
    index, x, y, width, height, label, bgColor,
    enableResizing, disableDragging, dragGrid, commitOnStop,
    onSelect, onDragStop, onResizeCommit,
  } = props;

  const style = useMemo(
    () => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "solid 1px #ddd",
      background: `${bgColor}`,
      color: colors.white,
      fontSize: 12,
      cursor: "pointer",
    }),
    [bgColor]
  );

  const size = useMemo(() => ({ width, height }), [width, height]);
  const position = useMemo(() => ({ x, y }), [x, y]);

  const handleClick = useCallback(() => onSelect(index), [onSelect, index]);

  const handleDragStop = useCallback(
    (e: any, d: any) => {
      e.stopPropagation();
      onDragStop(index, d);
    },
    [onDragStop, index]
  );

  const handleResize = useCallback(
    (_e: any, _direction: any, ref: any, _delta: any, pos: any) =>
      onResizeCommit(index, ref, pos),
    [onResizeCommit, index]
  );

  return (
    <Rnd
      onClick={handleClick}
      style={style}
      size={size as any}
      position={position as any}
      onDragStop={handleDragStop}
      {...(commitOnStop
        ? { onResizeStop: handleResize }
        : { onResize: handleResize })}
      bounds="parent"
      enableResizing={enableResizing}
      disableDragging={disableDragging}
      dragGrid={dragGrid}
    >
      {label}
    </Rnd>
  );
}

export default React.memo(StallBoxBase);
